
import React from "react";
import Header from "@/components/header";
import DesktopNavSheet from "@/components/header/DesktopNavSheet";
import MobileActionBar from "@/components/navigation/MobileActionBar";
import { Toaster } from "@/components/ui/toaster";
import { useIsMobile } from "@/hooks/use-mobile";
import { LoadingProvider } from "@/context/LoadingContext";
import { GlobalProgressBar } from "@/components/ui/global-progress-bar";
import { NotificationPrompt } from "@/components/NotificationPrompt";

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();

  return (
    <LoadingProvider>
      <GlobalProgressBar />
      <div className="min-h-screen flex flex-col bg-background w-full overflow-x-hidden">
        <Header />
        <div className="flex-1 flex relative w-full">
          {/* Desktop Navigation Sidebar */}
          {!isMobile && (
            <aside className="flex-shrink-0">
              <DesktopNavSheet />
            </aside>
          )}
          
          {/* Main Content with proper constraints */}
          <main className="flex-1 min-w-0 overflow-y-auto pb-24 md:pb-0">
            <NotificationPrompt />
            {children}
          </main>
        </div>
        
        {/* Mobile Action Bar */}
        <MobileActionBar />
        
        <Toaster />
      </div>
    </LoadingProvider>
  );
};
